export const back = {
  easeIn: 'cubic-bezier(0.600, 0, 0.735, 0.045)',
  easeOut: 'cubic-bezier(0.175, 0.885, 0.320, 1)',
  easeInOut: 'cubic-bezier(0.680, 0, 0.265, 1)'
};
export const cubic = {
  easeIn: 'cubic-bezier(0.550, 0.055, 0.675, 0.190)',
  easeOut: 'cubic-bezier(0.215, 0.610, 0.355, 1.000)',
  easeInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)'
};
export const quad = {
  easeIn: 'cubic-bezier(0.550, 0.085, 0.680, 0.530)',
  easeOut: 'cubic-bezier(0.250, 0.460, 0.450, 0.940)',
  easeInOut: 'cubic-bezier(0.455, 0.030, 0.515, 0.955)'
};
export const quint = {
  easeIn: 'cubic-bezier(0.755, 0.050, 0.855, 0.060)',
  easeOut: 'cubic-bezier(0.230, 1.000, 0.320, 1.000)',
  easeInOut: 'cubic-bezier(0.860, 0.000, 0.070, 1.000)'
};